<template>
  <form-section :title="$t('Integrations_Settings_BasicSettings')">
    <rest-form-item
      :label="$t('Integrations_Field_Name')"
      :hint="$t('Integrations_Field_Name_Description')"
      prop="name"
    >
      <el-input
        v-model="model.name"
        :placeholder="$t('Integrations_Field_Name')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('Integrations_Sportradar_Field_Sport')"
      :hint="$t('Integrations_Sportradar_Field_Sport_Description')"
      prop="params.sport"
    >
      <enum-select
        v-model="model.params.sport"
        :placeholder="$t('Integrations_Sportradar_Field_Sport')"
        :options="availableSports"
        :disabled="!!model.id"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('Integrations_Sportradar_Field_Identifier')"
      :hint="$t('Integrations_Sportradar_Field_Identifier_Description')"
      prop="params.identifier"
    >
      <enum-select
        v-model="model.params.identifier"
        :placeholder="$t('Integrations_Sportradar_Field_Identifier')"
        :options="identifierList"
        :disabled="!!model.id || !!liveActivityFlag"
      />
    </rest-form-item>
    <rest-form-item
      v-if="$hasFeature('iosLiveActivities')"
      :label="$t('Integrations_Sportradar_Live_Activities_Title')"
    >
      <toggle
        v-model="liveActivityFlag"
        :active-text="$t('Integrations_Sportradar_Live_Activities_Active')"
        :inactive-text="$t('Integrations_Sportradar_Live_Activities_Inactive')"
        :disabled="isLiveActivitiesDisabled"
      >
      </toggle>
    </rest-form-item>
    <rest-form-item
      v-if="model.params.liveActivities"
      :label="$t('Integrations_Sportradar_Field_Ios_App')"
      :hint="$t('Integrations_Sportradar_Field_Ios_App_Description')"
      prop="params.liveActivitiesAppId"
    >
      <el-select
        v-model="model.params.liveActivitiesAppId"
        :placeholder="$t('Integrations_Sportradar_Field_Ios_App')"
        :disabled="!!model.id"
      >
        <el-option
          v-for="item in iosLiveActivityApplicationList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </rest-form-item>
  </form-section>
</template>

<script>
import EnumSelect from '@/common/components/form/EnumSelect'
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import Toggle from '@/common/components/form/Toggle'
import { listIdentifierLabel } from '@/modules/lists/enum/ListRecordEnums'
import { SportsLabel } from '@/modules/integrations/types/sportradar/enum/SportsLabelEnum'
import { LiveActivitiesSports } from '@/modules/integrations/types/sportradar/enum/LiveActivitiesSportsEnum'
import { validateIdentifier } from '@/modules/lists/utils'
import _ from 'lodash'
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'SportradarSettings',

  components: {
    Toggle,
    FormSection,
    RestFormItem,
    EnumSelect
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },
  created() {
    this.fetchApps()
      .then(response => {
        this.iosLiveActivityApplicationList = response.data
      })
      .catch(error => {
        console.error('Error fetching data:', error)
      })
  },

  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          identifier: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          liveActivitiesAppId: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      },
      listIdentifierLabel,
      SportsLabel,
      iosLiveActivityApplicationList: {}
    }
  },

  computed: {
    features() {
      return this.$store.state.app.features || {}
    },

    identifierList() {
      const filtered = Object.keys(this.listIdentifierLabel).filter(key =>
        validateIdentifier(key, this.features)
      )
      return _.pick(this.listIdentifierLabel, filtered)
    },

    availableSports() {
      return Object.fromEntries(
        Object.entries(SportsLabel).filter(([key]) =>
          this.$store.state.app.project.sportradar_sports.includes(key)
        )
      )
    },
    iosLiveActivityApplicationsEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `applications/applications-with-ios-credentials`
      })
    },
    liveActivityFlag: {
      get() {
        if (!this.model.params.liveActivities) {
          this.$set(this.model.params, 'liveActivities', 0)
        }
        return this.model.params.liveActivities
      },
      set(newVal) {
        this.model.params.liveActivities = newVal
        this.$set(this.model.params, 'identifier', 'device_id')
      }
    },

    isLiveActivitiesDisabled() {
      return (
        !!this.model.id ||
        !LiveActivitiesSports.includes(this.model.params.sport)
      )
    }
  },

  watch: {
    'model.params.sport'(sport) {
      if (!LiveActivitiesSports.includes(sport) && this.liveActivityFlag) {
        this.model.params.liveActivities = 0
        this.$delete(this.model.params, 'liveActivitiesAppId')
      }
    }
  },

  methods: {
    fetchApps() {
      return RestApi({
        ...this.iosLiveActivityApplicationsEndpoint
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/sportradar/SportradarSettings.vue